import avatar1 from "../../../../../assets/images/avatar1.png";

export const OrgUsersItem = ({ userData, directInvite }) => (
  <li className="space-between align-items-center org-users-item" onClick={() => directInvite(userData.email)}>
    <div className="align-items-center">
      <div>
        <img src={avatar1} width={36} className="m-r-5" alt="" />
      </div>
      <div className="flex-col">
        <span className="bold">
          u{userData.id} {userData.first_name} {userData.last_name}
        </span>
        <span className="font-10">{userData.email}</span>
      </div>
    </div>
  </li>
);
